<template>
  <span :class="className">
    <span v-if="isUndefined" class="text-muted">–</span>
    <template v-else>
      <template v-if="isPositive">+</template><number
        :number="change"
        :options="{minimumFractionDigits: 0, maximumFractionDigits: 0}"
      />%
    </template>
  </span>
</template>

<script>
  export default {
    props: {
      current: {type: Number, required: true},
      diff: {type: Number, required: true},
    },
    computed: {
      isUndefined () {
        return (this.current - this.diff) === 0
      },
      isPositive () {
        return !this.isUndefined && this.diff > 0
      },
      className () {
        if (this.isUndefined) return 'text-muted'

        return this.diff > 0 ? 'text-success' : this.diff === 0 ? 'text-muted' : 'text-danger'
      },
      change () {
        if (this.isUndefined) return undefined

        return this.diff / (this.current - this.diff) * 100
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/number-change.vue